import React from 'react';
import { ProductsType } from 'src/constants/products';
import { useGetUsersMeQuery } from 'src/services/usersService';
import { ROLES } from 'src/constants/roles';
import { COSSUPORT_DEMO_PAGE } from 'src/shared/constants';
import { CreateNewAgentCard } from 'src/components/HomePageComponents/CreateNewAgent/CreateNewAgentCard';
import { useAppSelector } from 'src/store';
import { API_VERSION } from 'src/constants/api-routes';

export const CreateNewAgentContent = (_props?: { close?: () => void }) => {
  const { data: userInfo } = useGetUsersMeQuery();
  const isCosupportManager = userInfo?.role === ROLES.COSSUPORT_MANAGER;
  const { isInactivePlan } = useAppSelector((s) => s.planSlice);
  const version = localStorage.getItem('API_VERSION') || API_VERSION.V1;
  const isV2 = version === API_VERSION.V2;

  return (
    <div>
      <p className="pb-2.5 font-medium opacity-50 text-sm font-jamjuree">Select a product</p>
      <div className="flex gap-2.5">
        <CreateNewAgentCard
          type={ProductsType.agent}
          isAdmin={isCosupportManager}
          navigationLink={COSSUPORT_DEMO_PAGE}
          disabled={isInactivePlan || isV2}
        />
        <CreateNewAgentCard type={ProductsType.customer} disabled={isInactivePlan} />
        <CreateNewAgentCard
          disabled={isInactivePlan || isV2}
          type={ProductsType.bi}
          isAdmin={isCosupportManager}
          navigationLink={COSSUPORT_DEMO_PAGE}
        />
      </div>
    </div>
  );
};
